// extracted by mini-css-extract-plugin
export var container = "_jq-0";
export var dotAnimation = "_jq-2";
export var dotsLoading = "_jq-1";